// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Js7D","filesListContainer":"PosDisputesFiles_filesListContainer__37o5t","filesButton":"PosDisputesFiles_filesButton__2U38G"};